import { HeroAboutView } from "@softmax/product-ux/editor";
import type { ReactNode } from "react";
import { EditableField } from "./editable-field";
import { useEditModeMaybe } from "../use-edit-mode-maybe";
import {
  blurbMaxCharacters,
  closingLineMaxCharacters,
} from "../store-page/content-limits";

export function HeroAbout({
  blurb,
  closingLine,
  children,
}: {
  blurb: string;
  closingLine: string | null;
  children: ReactNode;
}) {
  const mode = useEditModeMaybe();

  if (!mode?.editing) return <>{children}</>;

  const { editor } = mode;
  return (
    <HeroAboutView>
      <EditableField
        value={editor.content.blurb}
        liveValue={blurb}
        onChange={(value) => editor.updateContent({ blurb: value || null })}
        maxLength={blurbMaxCharacters}
        ariaLabel="Edit premise"
        placeholder="What is this game, in one or two sentences?"
        lintWarnings={editor.lintWarnings.filter(
          (warning) => warning.field === "blurb",
        )}
      />
      <EditableField
        value={editor.content.closing_line}
        liveValue={closingLine ?? ""}
        onChange={(value) =>
          editor.updateContent({ closing_line: value || null })
        }
        maxLength={closingLineMaxCharacters}
        ariaLabel="Edit closing line"
        placeholder="A second line about the game — optional"
        lintWarnings={editor.lintWarnings.filter(
          (warning) => warning.field === "closing_line",
        )}
      />
    </HeroAboutView>
  );
}
